import "@hotwired/turbo"

import "./globals/jquery"
import "./globals/popper"
import "./globals/moment"

import "bootstrap"
import "bootstrap/dist/css/bootstrap.css"

import "jquery-ui/ui/data"
import "jquery-ui/ui/scroll-parent"
import "jquery-ui/ui/version"
import "jquery-ui/ui/widget"
import "jquery-ui/ui/widgets/mouse"
import "jquery-ui/ui/widgets/sortable"

import "#/application/js"
import "#/requests/js"
import "#/admin/admins/js"
import "#/admin/requests/js"
